export enum Distance {
  ZERO = '0',
  FIVE = '5',
  TEN = '10',
  FIFTEEN = '15'
}
